






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { SuggestionAction } from '../../entities/suggestions'

@Component<ActionLabel>({
})
export default class ActionLabel extends Vue {

    @Prop({ type: String, default: '' }) public action!: SuggestionAction

    public get sentiment() {
        return this.action === 'not-now' ? 'negative' : 'positive'
    }

    public get display() {
        return this.action === 'not-now' ? 'Not now' : 'Let\'s Do It'
    }
}
